export enum LoginState {
  LOGIN = 'LOGIN',
  MFA = 'MFA',
  SOFTWARE_MFA = 'SOFTWARE_MFA',
  SOFTWARE_MFA_SETUP = 'SOFTWARE_MFA_SETUP',
  REGISTER = 'REGISTER',
  RESET_REQUIRED = 'RESET_REQUIRED',
}

export type MFADetails = {
  factorId: string;
  mfaChallengeId: string;
  maskedIdentifier: string;
};

export type TotpDetails = {
  sessionId: string;
  isSetup: boolean;
};

export type TotpSetupDetails = {
  sessionId: string;
  secretCode: string;
  email: string;
};

export type RegisterState = {
  email: string;
  sessionId: string;
};

export type ResetRequiredState = {
  email: string;
};
